"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { isValidElement } from "react";
import Tooltip from "./tooltip.js";
export default function renderWrappedTooltipOrChild(child, modifier) {
    return child && isValidElement(child) && child.type === Tooltip
        ? React.Children.map(child, c => !!c && _jsx(Tooltip, { triggerElement: modifier(c.props.triggerElement), children: child.props.children }))
        : modifier(child);
}
//# sourceMappingURL=render-wrapped-tooltip-or-child.js.map